import { render, staticRenderFns } from "./UnifiedQueryNew.vue?vue&type=template&id=fe2e84bc&scoped=true"
import script from "./UnifiedQueryNew.vue?vue&type=script&lang=js"
export * from "./UnifiedQueryNew.vue?vue&type=script&lang=js"
import style0 from "./UnifiedQueryNew.vue?vue&type=style&index=0&id=fe2e84bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2e84bc",
  null
  
)

export default component.exports